module.exports = __webpack_public_path__ + "static/media/VanityFair.fa156ad5.png";